import { render } from "./EstadisticaGestiones.vue?vue&type=template&id=251fa727&scoped=true"
import script from "./EstadisticaGestiones.vue?vue&type=script&lang=js"
export * from "./EstadisticaGestiones.vue?vue&type=script&lang=js"

import "./EstadisticaGestiones.vue?vue&type=style&index=0&id=251fa727&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-251fa727"]])

export default __exports__